export { default, type TariffCardProps } from './TariffCard';
